(function () {
  'use strict';

  function num(v, fallback) {
    var n = Number(v);
    return Number.isFinite(n) && n >= 0 ? n : fallback;
  }

  function format(n) {
    try { return new Intl.NumberFormat('es-ES').format(Math.round(n)); }
    catch (e) { return String(Math.round(n)); }
  }

  function apply(el, amparo, fulgencio, updatedAt) {
    amparo = num(amparo, 0);
    fulgencio = num(fulgencio, 0);
    var total = amparo + fulgencio;
    var ap = total > 0 ? (amparo / total) * 100 : 50;
    var fp = 100 - ap;

    var upBar = el.querySelector('[data-gp-up-bar]');
    var downBar = el.querySelector('[data-gp-down-bar]');
    var upPercent = el.querySelectorAll('[data-gp-up-percent]');
    var downPercent = el.querySelectorAll('[data-gp-down-percent]');
    var upPoints = el.querySelectorAll('[data-gp-up-points]');
    var downPoints = el.querySelectorAll('[data-gp-down-points]');
    var updated = el.querySelector('[data-gp-updated]');

    if (upBar) upBar.style.width = ap.toFixed(2) + '%';
    if (downBar) downBar.style.width = fp.toFixed(2) + '%';
    upPercent.forEach(function (node) { node.textContent = Math.round(ap) + '%'; });
    downPercent.forEach(function (node) { node.textContent = Math.round(fp) + '%'; });
    upPoints.forEach(function (node) { node.textContent = format(amparo); });
    downPoints.forEach(function (node) { node.textContent = format(fulgencio); });
    if (updated && updatedAt) updated.textContent = updatedAt;

    el.setAttribute('aria-label', 'Marcador: Amparo ' + Math.round(ap) + '%, Fulgencio ' + Math.round(fp) + '%');
    el.dataset.gpLoaded = 'true';
    delete el.dataset.gpError;
  }

  function manual(el) {
    apply(el, num(el.dataset.gpAmparo, 0), num(el.dataset.gpFulgencio, 0));
  }

  function csv(v) {
    return (v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean).join('|');
  }

  function automaticUrl(el) {
    var raw = (el.dataset.gpEndpoint || '').trim();
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      if (el.dataset.gpStart) url.searchParams.set('start', el.dataset.gpStart);
      if (el.dataset.gpAmparoTypes) url.searchParams.set('amparo_types', csv(el.dataset.gpAmparoTypes));
      if (el.dataset.gpFulgencioTypes) url.searchParams.set('fulgencio_types', csv(el.dataset.gpFulgencioTypes));
      if (el.dataset.gpAmparoLot) url.searchParams.set('amparo_lot_id', el.dataset.gpAmparoLot);
      if (el.dataset.gpFulgencioLot) url.searchParams.set('fulgencio_lot_id', el.dataset.gpFulgencioLot);
      url.searchParams.set('regular_points', String(num(el.dataset.gpRegularPoints, 1)));
      url.searchParams.set('lot_points', String(num(el.dataset.gpLotPoints, 5)));
      return url.toString();
    } catch (e) {
      return raw;
    }
  }

  var requestCache = {};
  function fetchScore(url, force) {
    if (!url) return Promise.reject(new Error('Sin endpoint'));
    if (!force && requestCache[url]) return requestCache[url];
    requestCache[url] = fetch(url, { cache: 'no-store', credentials: 'omit', mode: 'cors' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var a = num(data.amparo, NaN);
        var f = num(data.fulgencio, NaN);
        if (!Number.isFinite(a) || !Number.isFinite(f)) throw new Error('Formato de marcador no válido');
        return { amparo: a, fulgencio: f, updated_at: data.updated_at || data.updatedAt || '' };
      });
    return requestCache[url];
  }

  function updateAuto(el, force) {
    var url = automaticUrl(el);
    if (!url) { manual(el); return Promise.resolve(); }
    return fetchScore(url, force)
      .then(function (score) { apply(el, score.amparo, score.fulgencio, score.updated_at); })
      .catch(function () {
        el.dataset.gpError = 'true';
        manual(el);
      });
  }

  function boot() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-gp-score]'));
    if (!widgets.length) return;

    widgets.forEach(function (el) {
      var mode = el.dataset.gpMode || 'manual';
      if (mode === 'automatic') updateAuto(el, false);
      else manual(el);
    });

    var refreshValues = widgets.map(function (el) { return num(el.dataset.gpRefresh, 0); }).filter(function (n) { return n > 0; });
    if (refreshValues.length) {
      var seconds = Math.min.apply(Math, refreshValues);
      setInterval(function () {
        requestCache = {};
        widgets.forEach(function (el) {
          if ((el.dataset.gpMode || 'manual') === 'automatic') updateAuto(el, true);
        });
      }, seconds * 1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
